/**
 * @description 3个子配置，通用配置|主题配置|网络配置导出
 */
import { network } from './net.config';
import { server } from './server.config';
import { setting } from './setting.config';
import { theme } from './theme.config';
import { menus } from './menus.config';
import { login } from './login.config';
import { resource } from './resource.config';

export default { ...network, ...server, ...setting, ...theme, ...menus, ...login, ...resource };
